// extracted by mini-css-extract-plugin
export default {"menuBlock":"OJ-z","title":"PJ-z","nav":"QJ-z","flexCell":"RJ-z","facetLink":"SJ-z"};